document.addEventListener('DOMContentLoaded', () => {
  const desktop = document.documentElement.dataset.mintroveDevice === 'desktop';
  document.body.classList.toggle('site-render--desktop', desktop);
  document.body.classList.toggle('site-render--mobile', !desktop);
  document.querySelectorAll('[data-render-router]').forEach((router) => {
    const mobile = router.querySelector(':scope > [data-mobile-path]');
    const template = router.querySelector(':scope > template[data-desktop-template]');
    if (desktop && template) {
      mobile?.replaceWith(template.content.cloneNode(true));
      template.remove();
    } else {
      template?.remove();
    }
    router.dataset.activePath = desktop ? 'desktop' : 'mobile';
  });
  document.dispatchEvent(new CustomEvent('mintrove:render-path-ready', { detail: { device: desktop ? 'desktop' : 'mobile' } }));
});
